import { mapState, mapMutations, mapActions } from "vuex";

export default {
    computed: {
        ...mapState({
            parceiro: (estado) => estado.parceiroConfig.nome,
            parceiroConfig: (estado) => estado.parceiroConfig,
            cpfCnpj: (estado) => estado.passosRetornarDividas.pessoa.pesCpfCnpj,
			showMessageModal: (estado) => estado.messageModal.show
        }),

        parceiroConfigCorSecundariaCorPrimaria() {
            return this.parceiro ? this.parceiroConfig.estilo.corSecundaria : 'var(primaryColor)';
        },

        parceiroConfigCorSecundariaCorSecundaria() {
            return this.parceiro ? this.parceiroConfig.estilo.corSecundaria : 'var(secondaryColor)';
        },

        corPrimaria() {
            return this.parceiro ? this.parceiroConfig.estilo.corPrimaria : 'var(primaryColor)';
        },

        nomeParceiro() {
            return "Mercobran";
        }
    },

    methods: {
        ...mapMutations(["CHANGE_MESSAGE_MODAL", "CHANGE_MESSAGE_SNACKBAR", "SET_LOADING_MESSAGE", "SET_LOADING"]),

        ...mapActions(["action_salvar_etapa"])
    },

    actions: {
        formatarData(data) {
            if (data.indexOf('T') != -1) {
                data = data.substring(0, data.indexOf('T'));
            }

            let arrayData = data.split("-");
            let dia = arrayData[2].length == 2 ? arrayData[2] : `0${arrayData[2]}`;
            let mes = arrayData[1].length == 2 ? arrayData[1] : `0${arrayData[1]}`;
            return `${dia}/${mes}/${arrayData[0]}`;
        }
    }
}